import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import "./categoryItem.css";

const CategoryItem = ({ category }) => {
  return (
    <Link
      className="dev-vg-category-item dev-vg-g-focus"
      to={`/category/${category.URL}`}
    >
      <div className="dev-vg-category-item__grid grid grid-cols-3 gap-1 transform hover:-translate-y-2 opacity-100 hover:opacity-90 transition-all duration-200">
        <div className="dev-vg-category-item__image-container col-span-3">
          <GatsbyImage
            className="dev-vg-category-item__image object-cover w-full rounded-t-xl"
            alt={category.products?.data?.[0]?.Name}
            image={getImage(
              category.products?.data?.[0]?.attributes?.FeaturedImage?.data
                ?.attributes?.localFile
            )}
          />
        </div>
        <div className="dev-vg-category-item__image-container">
          <GatsbyImage
            className="dev-vg-category-item__image object-cover w-full rounded-bl-xl"
            alt={category.products?.data?.[1]?.Name}
            image={getImage(
              category.products?.data?.[1]?.attributes?.FeaturedImage?.data
                ?.attributes?.localFile
            )}
          />
        </div>
        <div className="dev-vg-category-item__image-container">
          <GatsbyImage
            className="dev-vg-category-item__image object-cover w-full"
            alt={category.products?.data?.[2]?.Name}
            image={getImage(
              category.products?.data?.[2]?.attributes?.FeaturedImage?.data
                ?.attributes?.localFile
            )}
          />
        </div>
        <div className="dev-vg-category-item__image-container">
          <GatsbyImage
            className="dev-vg-category-item__image object-cover w-full rounded-br-xl"
            alt={category.products?.data?.[3]?.Name}
            image={getImage(
              category.products?.data?.[3]?.attributes?.FeaturedImage?.data
                ?.attributes?.localFile
            )}
          />
        </div>
      </div>
      <div className="dev-vg-category-item__content mt-4">
        <h5 className="font-bold text-pre-lg leading-7 tracking-tightsy flex items-center">
          {category?.Name}{" "}
          <span className="text-ui-gray-plus-2 ml-1">
            ({category?.productsCount} Items)
          </span>
          <i className="ml-2 vg-arrow-right text-ui-gray-plus-2" />
        </h5>
        <div className="mt-2 text-ui-gray-plus-4 text-pre-tiny leading-6 tracking-tightly font-normal">
          {category?.Description ||
            "High resolution JPG backgrounds that can be printable even at billboard size"}
        </div>
      </div>
    </Link>
  );
};

CategoryItem.defaultProps = {
  category: {
    URL: "/category",
    Name: "Name",
    Description:
      "High resolution JPG backgrounds that can be printable even at billboard size",
  },
};

CategoryItem.propTypes = {
  category: PropTypes.object,
};

export default CategoryItem;
